import { MortgageInterface } from '@app/interfaces/mortgage.interface';

export class FillingScore2200 {
    static check(mortgage: MortgageInterface): boolean {
        return !!mortgage._contacts.every(
            (a) =>
                a.firstName &&
                a.lastName &&
                a.familyName &&
                a.education &&
                a.job &&
                a.email &&
                a.address.permanent.street &&
                a.address.permanent.houseNumber &&
                a.address.permanent.zipCode &&
                a.address.permanent.city &&
                a.address.permanent.livingSince &&
                a.address.mailing.street &&
                a.address.mailing.houseNumber &&
                a.address.mailing.zipCode &&
                a.address.mailing.city &&
                a.address.courier.street &&
                a.address.courier.houseNumber &&
                a.address.courier.zipCode &&
                a.address.courier.city
        );
    }
}
